export default "__VITE_ASSET__Bp3zw18A__"